import api from '../utils/api';

const campusService = {
  listCampuses: async (schoolId) => {
    try {
      return await api.get('/api/campuses', { params: schoolId ? { school_id: schoolId } : {} });
    } catch (error) {
      console.error('Error fetching campuses:', error);
      throw error;
    }
  },
  createCampus: async (data) => {
    try {
      return await api.post('/api/campuses', data);
    } catch (error) {
      console.error('Error creating campus:', error);
      throw error;
    }
  },
  updateCampus: async (campusId, data) => {
    try {
      return await api.put(`/api/campuses/${campusId}`, data);
    } catch (error) {
      console.error('Error updating campus:', error);
      throw error;
    }
  },
  deleteCampus: async (campusId) => {
    try {
      return await api.delete(`/api/campuses/${campusId}`);
    } catch (error) {
      console.error('Error deleting campus:', error);
      throw error;
    }
  },
};

export default campusService;
